// extracted by mini-css-extract-plugin
module.exports = {"mediatheque-pagination":"pagination_mediatheque-pagination__6eQei"};